import { useState } from "react";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { act } from "@/lib/hooks";
import { api } from "@/lib/api";
import { Field } from "@/components/common";
import { PasswordInput } from "@/components/PasswordInput";

const BLANK = { current: "", next: "", confirm: "" };

export function ChangePasswordButton({ className, onClick }) {
  return <button onClick={onClick} data-testid="change-password-button" className={className}><KeyRound className="h-4 w-4" /> Change password</button>;
}

export function ChangePasswordDialog({ open, onClose }) {
  const [f, setF] = useState(BLANK);
  const [done, setDone] = useState(null);
  const ok = f.current && f.next.length >= 8 && f.next === f.confirm;
  const close = () => { onClose(); setF(BLANK); setDone(null); };
  const save = async () => { const r = await act(() => api.post("/auth/password/change", { current_password: f.current, new_password: f.next })); if (r) setDone(r); };
  return (
    <>
      <Dialog open={open} onOpenChange={(o) => !o && close()}>
        <DialogContent data-testid="change-password-dialog">
          <DialogHeader><DialogTitle>Change password</DialogTitle><DialogDescription>We'll email you a confirmation link. Your new password only takes effect after you click it, and you'll be signed out everywhere.</DialogDescription></DialogHeader>
          {done ? <div className="space-y-2 text-sm" data-testid="change-password-sent">
            <p>{done.status === "sent" ? `Check ${done.to} for the confirmation link. It expires in 1 hour.` : `${done.to} is a demo address, so no email was sent. Use this link to confirm:`}</p>
            {done.confirm_url && <a className="break-all text-[#2B7F77] underline" href={done.confirm_url} data-testid="change-password-demo-link">{done.confirm_url}</a>}
          </div> : <div className="space-y-3">
            <Field label="Current password"><PasswordInput data-testid="current-password-input" autoComplete="current-password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} /></Field>
            <Field label="New password (min 8 characters)"><PasswordInput data-testid="new-password-input" autoComplete="new-password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} /></Field>
            <Field label="Confirm new password"><PasswordInput data-testid="confirm-password-input" autoComplete="new-password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} /></Field>
            {f.confirm && f.next !== f.confirm && <p className="text-xs text-rose-600" data-testid="password-mismatch">Passwords don't match.</p>}
          </div>}
          <DialogFooter>{done ? <Button onClick={close} data-testid="change-password-close">Done</Button>
            : <Button data-testid="change-password-submit" disabled={!ok} onClick={save} className="bg-[#13294B] hover:bg-[#1c3a66]">Send confirmation email</Button>}</DialogFooter>
        </DialogContent>
      </Dialog>
    </>);
}
